import { render } from "./RecentDeals.vue?vue&type=template&id=760045f4"
import script from "./RecentDeals.vue?vue&type=script&lang=js"
export * from "./RecentDeals.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__